import React from 'react';
import { Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SxStyle } from '../../types';

const styles: SxStyle = {
  container: {
    display: 'flex',
    alignItems: 'center',
    background: '#fff',
    py: 0,
    px: 2,
    minHeight: '40px',
    borderStyle: 'solid',
    borderWidth: '1px 0',
    borderColor: 'rgb(0, 0, 0, 12%)',
    boxShadow: '0px 2px 5px 0px #0000001A',
  },
};

interface Props {
  title: string;
  onClose: () => void;
}

export default function DrawerHeader({ title, onClose }: Props) {
  return (
    <Box sx={styles.container}>
      <Typography variant="body2" sx={{ flex: '1 1 auto' }}>
        {title}
      </Typography>
      <IconButton aria-label="close" onClick={onClose} size="small">
        <CloseIcon fontSize="inherit" />
      </IconButton>
    </Box>
  );
}
